import { render } from "./search-button.vue?vue&type=template&id=4e79fc02"
import script from "./search-button.vue?vue&type=script&lang=js"
export * from "./search-button.vue?vue&type=script&lang=js"
script.render = render

export default script